export default __webpack_public_path__ + "static/media/icons-outline-app-launcher-fill.9dba4d9d.svg";